import { render, staticRenderFns } from "./DoctorIndex.vue?vue&type=template&id=86302484&scoped=true&"
import script from "./DoctorIndex.vue?vue&type=script&lang=js&"
export * from "./DoctorIndex.vue?vue&type=script&lang=js&"
import style0 from "./DoctorIndex.vue?vue&type=style&index=0&id=86302484&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86302484",
  null
  
)

export default component.exports